import './style.less';

export default function () {
    return {
        link: (scope, element, attr) => {


            let video = document.getElementById('my-video');
            let imageBg = document.getElementById('my-image');

            scope.showConsole = true;



            video.addEventListener('canplay', function () {
                if (checkCached()) {
                    showVideo();
                } else {
                    console.info('Buffering...');
                    video.onprogress = progressHandler;
                }
            }, false);


            function progressHandler() {
                let progress = 100 * (this.buffered.end(0))/this.duration;
                scope.videoProgress = Math.round(progress) + '%';
                if (video.buffered.end(0) === video.duration) {
                    console.info('Video buffered!');
                    showVideo();
                    video.onprogress = null;
                }
            }

            function checkCached() {
                if (video.buffered.end(0) === video.duration) {
                    console.info('Video already cached!');
                    return true;
                }
                return false;
            }

            function showVideo() {
                video.className = "app-bg";
                imageBg.className = "app-bg hide";
                scope.showConsole = false;
            }




        },
        template: require('./view.html'),
        controller: ($rootScope) => {


        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/console/index.js